enum HttpMethodEnum {
    Get = 0
    ,Post = 1
    ,Put = 2
    ,None = 255
}

export default HttpMethodEnum;
